/**
 * description: 定时任务
 * author: bql
 * 2023/7/10 15:40
 */

import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class DataScheduleSettingApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'data-schedule-setting'
    }


    /**
     * 创建
     * @param param
     */
    public add(param) {
        return this.send(param,"add", this.Methods.POST)
    }

    /**
     * 修改
     * @param param
     */
    public update(param) {
        return this.send(param,"update", this.Methods.POST)
    }

    /**
     * 删除
     * @param params
     */
    public del(params) {
        return this.send(params,"del", this.Methods.POST)
    }

    /**
     * 停止/启动
     * @param params
     */
    public changesStatus(params) {
        return this.send(params,"changesStatus", this.Methods.POST)
    }


    /**
     * 立即执行
     * @param params
     */
    public ImmediateExecution(params) {
        return this.send(params,"ImmediateExecution", this.Methods.POST)
    }








}
 